import { Search } from '@audio-network/componentlibrary/icons'

import searchBoxStyles from '../../../SearchBox.module.css'
import {
	AiSearchComponent,
	AutocompleteItem,
	HighlightedText,
} from '../../components'
import { QueryHit } from '..'

export const SuggestionsAndPromptOption = ({
	item,
	hasSuggestions,
	activeItemId,
}: {
	item: QueryHit
	hasSuggestions: boolean
	activeItemId: number
}): JSX.Element => {
	const { query, objectID } = item
	const index = item.__autocomplete_id as number

	return (
		<button
			aria-selected={activeItemId === index}
			className={searchBoxStyles.option}
			data-value={query}
			id={`${query}-listbox-option`}
			role="option"
			type="button"
		>
			{objectID === 'promptAI' ? (
				<AiSearchComponent prompt={query} showExplanation={!hasSuggestions} />
			) : (
				<AutocompleteItem
					icon={<Search size="medium" />}
					title={<HighlightedText AlgoliaHit={item} fields="query" />}
					data-testid="query-suggestion"
				/>
			)}
		</button>
	)
}
